
<template>
    
        <mars-view class="type-select-box"><mars-view v-if="title" class="item-title">
        {{ title }}
        <mars-view class="require-icon"></mars-view></mars-view><mars-view class="type-item-box"><mars-view v-for="typeItem, index in typeList" :key="index" :class="['type-item', activeType === typeItem.value ? 'active' : '']" @click.native="onTypeSelect(typeItem)">
            {{ typeItem.value }}
        </mars-view></mars-view><pop-select :is-show="isShowTypeSelect" :cur-type="curType" :shadow-close="true" @typeChange="typeChange" @close="onClose"></pop-select></mars-view>
    
</template>

<script>
import popSelect from "../../../components/clue/typeSelect.vue";
const typeExpand = [{
  value: '交通运输',
  group: '交通律师'
}, {
  value: '婚姻继承',
  group: '婚姻律师'
}, {
  value: '劳动社保',
  group: '劳动律师'
}, {
  value: '经济纠纷',
  group: '经济律师'
}, {
  value: '合同纠纷',
  group: '合同律师'
}];
const typeMore = [{
  value: '刑事案件',
  group: '刑事律师'
}, {
  value: '行政相关',
  group: '行政律师'
}, {
  value: '房地产',
  group: '房产律师'
}, {
  value: '其他',
  group: '专业律师'
}];
export default {
  props: {
    title: {
      type: String,
      default: '选择您感兴趣的项目'
    },
    curType: {
      type: String,
      default: ''
    },
    // all 展开  more 显示更多
    selectType: {
      type: String,
      default: 'all'
    }
  },
  components: {
    'pop-select': popSelect
  },
  watch: {
    curType: {
      handler(val) {
        if (!val) {
          return;
        }
        for (let i = 0; i < this.typeList.length; i++) {
          if (this.typeList[i].value === val) {
            this.activeType = val;
            return;
          }
        }
        if (this.selectType === 'more') {
          typeMore.forEach(item => {
            if (item.value === val) {
              this.activeType = '更多';
            }
          });
        }
      },
      immediate: true
    }
  },
  computed: {
    typeList() {
      if (this.selectType === 'more') {
        return this.moreTypeList;
      }
      return this.allTypeList;
    }
  },
  data() {
    return {
      // 咨询类型-列表
      moreTypeList: [...typeExpand, {
        value: '更多',
        group: '更多'
      }],
      allTypeList: [...typeExpand, ...typeMore],
      activeType: '',
      isShowTypeSelect: false
    };
  },
  methods: {
    /**
     * 类型选择
     * @param {object} item 类型信息
     */

    onTypeSelect(item) {
      if (!item.value || this.curType === item.value) {
        return;
      }
      if (item.value === '更多') {
        this.isShowTypeSelect = true;
        return;
      }
      this.$emit('typeSelect', item);
    },
    /**
     * 类型修改
     * @param {object} item
     */

    typeChange(item) {
      if (!item || !item.value || this.curType === item.value) {
        return;
      }
      this.$emit('typeSelect', item);
    },
    /**
     * 关闭弹窗
     */

    onClose() {
      this.isShowTypeSelect = false;
    }
  }
};
</script>

<style scoped>
.type-select-box .item-title {
  display: flex;
  align-items: center;
  color: #1e1f24;
  font-family: PingFang SC;
  font-size: 4.11vw;
  font-style: normal;
  font-weight: 500;
  line-height: 1;
}
.type-select-box .item-title .require-icon {
  width: 1.93vw;
  height: 1.69vw;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/mapClue/require-icon.png') no-repeat center / 100% 100%;
}
.type-select-box .type-item-box {
  display: flex;
  flex-wrap: wrap;
}
.type-select-box .type-item-box .type-item {
  width: 28.42vw;
  height: 9.66vw;
  border-radius: 2.17vw;
  background: #f5f6f9;
  color: #848691;
  font-family: PingFang SC;
  font-size: 3.86vw;
  font-style: normal;
  font-weight: 400;
  line-height: 9.66vw;
  text-align: center;
  margin-top: 3.14vw;
  margin-right: 3.14vw;
}
.type-select-box .type-item-box .type-item:nth-child(3n) {
  margin-right: 0;
}
.type-select-box .type-item-box .type-item.active {
  color: #05f;
  font-weight: 600;
}

</style>
